import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * Update user variables in Firestore
 */
export const updateUservars = async (
  uid: string,
  data: {
    firstName?: string;
    lastName?: string;
    dateOfBirth?: string;
    phone?: string;
    email?: string;
    [key: string]: any;
  }
): Promise<void> => {
  const uservarsRef = doc(db, 'uservars', uid);
  await setDoc(uservarsRef, data, { merge: true });
};

/**
 * Get user variables from Firestore
 */
export const getUserVars = async (uid: string): Promise<any | null> => {
  const uservarsRef = doc(db, 'uservars', uid);
  const uservarsDoc = await getDoc(uservarsRef);
  
  if (uservarsDoc.exists()) {
    return uservarsDoc.data();
  }
  
  return null;
};
